module.exports = __webpack_public_path__ + "asset/image-Heart-Hands-73fc3ff61d22d1db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Heart-Hands.svg
// module id = Ojfb
// module chunks = 0